import { ViewIds, ViewpointSavedViewSettings } from '@ardoq/api-types';
import { pick } from 'lodash';
import { savedWithViewpoint } from '../viewpointViewSettings';

export const getViewSettingsToSave = (
  viewSettings: Record<string, any>,
  viewId: ViewIds
): ViewpointSavedViewSettings => ({
  [viewId]: pick(viewSettings, savedWithViewpoint(viewId)),
});
